import React, { useState } from "react";
import styles from "./HotelSuggestionForm.module.css";
import { submitHotelSuggestion } from "./hotelSuggestionApi";

const initialFormData = {
  name: "",
  email: "",
  query: "",
};

const HotelSuggestionForm = () => {
  const [formData, setFormData] = useState(initialFormData);

  const [status, setStatus] = useState({
    type: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    setStatus({ type: "", message: "" });

    try {
      await submitHotelSuggestion(formData);

      setStatus({
        type: "success",
        message:
          "Thank you! Your suggestion has been submitted successfully.",
      });

      setFormData(initialFormData);
    } catch (error) {
      setStatus({
        type: "error",
        message:
          error.message ||
          "Unable to submit your suggestion. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.eyebrow}>
            HELP US IMPROVE
          </span>
          <p className={styles.title}>
            By recommending hotels or sharing corrections to existing information.
          </p>
          
        </div>

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label htmlFor="name">Name *</label>

            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              // placeholder="Enter your name"
              maxLength={150}
              autoComplete="name"
              required
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="email">Email *</label>

            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              // placeholder="Enter your email"
              autoComplete="email"
              required
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="query">
              Your Suggestion *
            </label>

            <textarea
              id="query"
              name="query"
              value={formData.query}
              onChange={handleChange}
              placeholder="Suggest a hotel or share corrections to existing information..."              rows={6}
              maxLength={5000}
              required
            />
          </div>

          {status.message && (
            <div
              className={`${styles.status} ${
                status.type === "success"
                  ? styles.success
                  : styles.error
              }`}
              role="alert"
              aria-live="polite"
            >
              {status.message}
            </div>
          )}

          <button
            type="submit"
            className={styles.submitButton}
            disabled={isSubmitting}
          >
            {isSubmitting
              ? "Submitting..."
              : "Submit Suggestion"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default HotelSuggestionForm;
